import { Link } from "react-router-dom";
import type { NewsItem } from "@/mocks/news";

interface NewsCardProps {
  item: NewsItem;
  variant?: "default" | "horizontal" | "feature";
}

export default function NewsCard({ item, variant = "default" }: NewsCardProps) {
  if (variant === "horizontal") {
    return (
      <Link
        to={`/news/detail/${item.id}`}
        className="group flex gap-3 md:gap-4 py-4 border-b border-background-200 last:border-b-0 cursor-pointer"
      >
        <div className="w-24 h-20 md:w-40 md:h-28 shrink-0 rounded-md overflow-hidden bg-background-200">
          <img
            src={item.thumbnail}
            alt={item.title}
            title={`${item.title} 星光传媒影视资讯`}
            className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
        </div>
        <div className="min-w-0 flex-1">
          <div className="flex items-center gap-2 mb-1.5">
            <span className="px-1.5 py-0.5 rounded text-[11px] bg-secondary-100 text-secondary-900">{item.category}</span>
            <span className="text-[11px] text-foreground-400">{item.publishedAt}</span>
          </div>
          <h3 className="text-sm md:text-base font-medium text-foreground-950 leading-snug line-clamp-2 group-hover:text-primary-700 transition-colors">
            {item.title}
          </h3>
          <p className="hidden sm:block text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2 mt-1.5">
            {item.summary}
          </p>
        </div>
      </Link>
    );
  }

  if (variant === "feature") {
    return (
      <Link to={`/news/detail/${item.id}`} className="group block relative rounded-lg overflow-hidden cursor-pointer">
        <div className="w-full aspect-[16/10] bg-background-200">
          <img
            src={item.cover}
            alt={item.title}
            title={`${item.title} 星光传媒影视资讯`}
            className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
        </div>
        <div className="absolute inset-0 bg-gradient-to-t from-primary-950 via-primary-950/50 to-transparent"></div>
        <div className="absolute inset-x-0 bottom-0 p-4 md:p-5">
          <div className="flex items-center gap-2 mb-2">
            <span className="px-2 py-0.5 rounded text-[11px] bg-accent-500 text-primary-950 font-medium">{item.category}</span>
            <span className="text-[11px] text-background-200/80">{item.publishedAt}</span>
          </div>
          <h3 className="font-heading text-lg md:text-xl font-medium text-background-50 leading-snug line-clamp-2">
            {item.title}
          </h3>
        </div>
      </Link>
    );
  }

  return (
    <Link to={`/news/detail/${item.id}`} className="group block cursor-pointer">
      <div className="w-full aspect-[16/10] rounded-lg overflow-hidden bg-background-200">
        <img
          src={item.thumbnail}
          alt={item.title}
          title={`${item.title} 星光传媒影视资讯`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="pt-3">
        <div className="flex items-center gap-2 mb-2">
          <span className="px-1.5 py-0.5 rounded text-[11px] bg-secondary-100 text-secondary-900">{item.category}</span>
          <span className="text-[11px] text-foreground-400">{item.publishedAt}</span>
        </div>
        <h3 className="text-sm md:text-base font-medium text-foreground-950 leading-snug line-clamp-2 group-hover:text-primary-700 transition-colors">
          {item.title}
        </h3>
        <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2 mt-2">{item.summary}</p>
      </div>
    </Link>
  );
}